import Keen from "keen-tracking";

import config from "./config";
import PersonStore from "./stores/PersonStore";

const client = new Keen({
  projectId: config.keen_project_id,
  writeKey: config.keen_write_key
});

const helpers = Keen.helpers;
const utils = Keen.utils;

const sessionCookie = utils.cookie("eventive-session");
if (!sessionCookie.get("guest_id")) {
  sessionCookie.set("guest_id", helpers.getUniqueId());
}

client.extendEvents(() => {
  const now = new Date();
  const utc = new Date(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds(),
    now.getUTCMilliseconds()
  );
  const utcDatetimeIndex = Keen.helpers.getDatetimeIndex(utc);

  return {
    tenant: {
      event_bucket: config.event_bucket,
      owner: config.owner
    },
    geo: {
      info: {
        /* Enriched */
      },
      ip_address: "${keen.ip}"
    },
    page: {
      info: {
        /* Enriched */
      },
      title: document.title,
      url: document.location.href
    },
    referrer: {
      info: {
        /* Enriched */
      },
      url: document.referrer
    },
    tech: {
      browser: helpers.getBrowserProfile(),
      info: {
        /* Enriched */
      },
      user_agent: "${keen.user_agent}"
    },
    time: utcDatetimeIndex,
    visitor_guest_id: sessionCookie.get("guest_id"),
    person: PersonStore.getPersonId(),
    keen: {
      addons: [
        {
          name: "keen:ip_to_geo",
          input: {
            ip: "geo.ip_address"
          },
          output: "geo.info"
        },
        {
          name: "keen:ua_parser",
          input: {
            ua_string: "tech.user_agent"
          },
          output: "tech.info"
        },
        {
          name: "keen:url_parser",
          input: {
            url: "page.url"
          },
          output: "page.info"
        },
        {
          name: "keen:referrer_parser",
          input: {
            referrer_url: "referrer.url",
            page_url: "page.url"
          },
          output: "referrer.info"
        }
      ]
    }
  };
});

export default client;



// WEBPACK FOOTER //
// ./src/app/tracking.js